export default "__VITE_ASSET__DnwA934L__"